import { TErrorNotification } from '@/types';
import tt from '@/i18n/utils/translateText';
import { notification } from '@/utils';

/* относится к platformContext */
export const showErrorNotification = ({ options, message }: TErrorNotification = {}) => {
  notification.error({
    message: options?.message || message || tt('shared.error.general'),
    description: !options?.withoutDescription ? options?.description || tt('shared.retryLater') : '',
  });
};
